
import axios from "axios"
	export default {
		data() {
			return {
				mobileMenuShowing: false,
				member: false,
				avatarHover: false,
				noMember: false,
				autocompleteLoaded: false,
				notificationCount: 0,
				cartCount: 0,
				notificationsMenu: false,
				notifications: false,
				noNotifications: true,
				config: false
			}
		},
		methods: {
			async markAllAsRead(){
				let nexusUrl = '/api/eq/nexus'
				if(this.member && (this.member.token)) nexusUrl += '?auth_token=' + this.member.token
				if(this.member)
				this.markingAsRead = true;
				var postObj = { "alerts":{ "mark_all_as_read_by_member":0 } }
				this.notifications.forEach(function(notification){
					notification.read = 1;
				});
				const data = await axios.post(nexusUrl, postObj)
				if(data){
					this.markingAsRead = false;
					this.readCount = false;
					this.notificationCount = 0;
				}
			},
			async markAsRead(notification){
				if(process.browser){
					var notificationLink = '/' +  notification.reference, thisObj = this;
					if(!notification.read){
						notification.read = 1;
						this.badgeCount--;
						var postObj = {
							alerts: {
								mark_as_read_by_member_by_ids: {
									ids: [notification.id]
								}
							}
						}
						const data = await axios.post(nexusUrl, postObj)
						if(data) location.href = notificationLink;
					} else location.href = notificationLink;
				}
			},
			async getNotifications(){
				const notifications = await this.$member.notifications.get()
				if(notifications && (notifications.length)) this.notifications = notifications
				else this.noNotifications = true
			},
			timeAgo(datePosted){
				var diff = new Date().getTime() - datePosted;
				var secondsAgo = Math.floor(diff / 1000 % 60), minutesAgo = Math.floor(diff / 1000 / 60 % 60),
					hoursAgo = Math.floor(diff / (1000 * 60 * 60) % 24), daysAgo = Math.floor(diff / (1000 * 60 * 60 * 24));
				var timeString = '';
				if(daysAgo) timeString = daysAgo == 1 ? 'a day ago' : daysAgo + ' days ago';
				else if(!daysAgo && hoursAgo) timeString = hoursAgo == 1 ? 'an hour ago' : hoursAgo + ' hours ago';
				else if(!daysAgo && !hoursAgo && minutesAgo){
					if(minutesAgo == 1) timeString = 'a minute ago';
					else timeString = minutesAgo < 10 ? 'a few minutes ago' : minutesAgo + ' minutes ago';
				}
				else if(!daysAgo && !hoursAgo && !minutesAgo && secondsAgo) timeString = 'just now';
				return timeString;
			}
		},
		watch: {
			notificationsMenu(){
				if(this.notificationsMenu){
					this.getNotifications()
				}
			}
		},
		async created() {
      this.config = await this.$configs.get('7c0408ca-2713-4d61-8120-8f0d7fe8ec16')
			const result = await this.$member.get(['memberemail', 'avatar', 'memberusername', 'memberstatus', 'memberbalance', 'tfu_status', 'educator_navigation', 'token'])
			if(result.memberusername){
				this.member = result
				console.log('member from header', this.member)
				const notificationCount = await this.$member.notifications.getCount()
				if(notificationCount) this.notificationCount = notificationCount
			} else this.noMember = true
			this.cartCount = await this.$cart.getCount()
			if(process.browser){
				const { autocomplete, getAlgoliaResults } = window['@algolia/autocomplete-js']
				const { createQuerySuggestionsPlugin } = window['@algolia/autocomplete-plugin-query-suggestions']
				const { algoliasearch } = window['algoliasearch']

				const appId = 'D96IXX9O9V';
				const apiKey = 'b343960d038b6a72de641c58713f58f6';
				const searchClient = algoliasearch(appId, apiKey);

				function tfSuggestionPlugin(searchModel){
					return createQuerySuggestionsPlugin({
					  transformSource({ source, onTapAhead }) {
					  	return {
				        getItems({ query }) {
				          return getAlgoliaResults({
				            searchClient,
				            queries: [
				              {
				                indexName: `staging_truefire_${searchModel}_en`,
				                query,
				              },
				            ],
				          });
				        },
				        getItemUrl({ item }) {
				        	let url
			          	if(item.guid.includes('COURSE')) url = item.link
			        		else if(item.guid.includes('EDUCATOR')) url = `/e${item.authorid}`
				          return url
				        },
								templates: {
				          item({ item, html }) {
					          let url = item.title
				        		if(url.includes('(Premium)')) url = url.replace('(Premium)', '')
					          return html`<a href="/search/?q=${encodeURIComponent(url)}" style="display:block;">
				            	${item.title}
					            </a>`
				          },
								},
								onSelect({setIsOpen}){
									setIsOpen(true)
								}
					  	}
					  }
					});
				}

				this.loadedAutocomplete = true
				const coursesSuggestionPlugin = tfSuggestionPlugin('courses'),
					jamsSuggestionPlugin = tfSuggestionPlugin('jams'),
					educatorsSuggestionPlugin = tfSuggestionPlugin('educators')
					
				this.$nextTick(() => {

					if(document.getElementById('headerAutocomplete')){
						this.$parent.autocompletes.push(
							autocomplete({
								insights: true,
								container: '#headerAutocomplete',
								detachedMediaQuery: 'none',
								openOnFocus: true,
								plugins: [coursesSuggestionPlugin, jamsSuggestionPlugin, educatorsSuggestionPlugin],
								placeholder: 'Search by genre, instrument, or style...',
								onSubmit({state, event}){
									if(state.query) location.href = `/search/?q=${encodeURIComponent(state.query)}`
								},
								reshape({sources, sourcesBySourceId, state}){
									return sources.map((source, index) => {
										return {
											...source,
											getItems(){
												const items = source.getItems(),
													topItems = [], bottomItems = []
												for(let i = 0; i < items.length; i++){
													items[i]['_highlightResult'].title.matchedWords.length ?
														topItems.push(items[i]) :
														bottomItems.push(items[i])
												}
												return [...topItems, ...bottomItems].slice(0, 5)
											}
										}
									})
								}
							})
						)
					}

					let mobileIsFocused

					if(document.getElementById('mobileAutocomplete')){
						this.$parent.autocompletes.push(
							autocomplete({
								insights: true,
								container: '#mobileAutocomplete',
								detachedMediaQuery: '',
								openOnFocus: true,
								plugins: [coursesSuggestionPlugin, jamsSuggestionPlugin, educatorsSuggestionPlugin],
								placeholder: 'What do you want to learn?',
								onStateChange({state}){
									mobileIsFocused = state.isOpen
								},
								onSubmit({state, event}){
									event.preventDefault()
									if(state.query) location.href = `/search/?q=${encodeURIComponent(state.query)}`
								},
								reshape({sources, sourcesBySourceId, state}){
									return sources.map((source, index) => {
										return {
											...source,
											getItems(){
												const items = source.getItems(),
													topItems = [], bottomItems = []
												for(let i = 0; i < items.length; i++){
													items[i]['_highlightResult'].title.matchedWords.length ?
														topItems.push(items[i]) :
														bottomItems.push(items[i])
												}
												return [...topItems, ...bottomItems].slice(0, 5)
											}
										}
									})
								}
							})
						)
					}

					addEventListener("keypress", (event) => {
						if(mobileIsFocused && event.code.toLowerCase() == 'enter'){
							const value = document.getElementById('autocomplete-2-input').value
							location.href = `/search/?q=${encodeURIComponent(value)}`
						}
					})

					this.autocompleteLoaded = true
				})
			}
		}
	}
